import { Pipe, PipeTransform } from '@angular/core';
import { Scouting } from '@generated/models';

@Pipe({
  name: 'scoutingLink',
})
export class ScoutingLinkPipe implements PipeTransform {
  transform(value: Pick<Scouting, 'id'>, ...args: string[]): string[] {
    return scoutingLink(value, args);
  }
}

export const scoutingLink = (scouting: Pick<Scouting, 'id'>, childRoutes: string[] = []): string[] => {
  return ['/', 'scoutings', scouting.id, ...childRoutes];
};
